// -- AT TYPE MAPS -- //

// list a of all entity @types
export const AT_TYPES = {
  PROVIDER: "Provider",
  REGION: "Region",
  COMPUTE_REGION: "ComputeRegion",
  ZONE: "Zone",
  COMPUTE_ZONE: "ComputeZone",
  SERVICE: "Service",
  SERVICES: {
    WORKSTATION: "WorkstationService",
    DISPLAY_GATEWAY: "DisplayGatewayService",
    CONTAINER: "StorageService",
    DATABASE: "DatabaseService",
    NODE: "NodeService",
    VPN_GATEWAY: "VirtualPrivateNetworkGatewayService",
    SNOWFLAKE: "SnowflakeService"
  },
  IMAGE: "Image",
  IMAGES: {
    WORKSTATION: ["WorkstationImage", "WorkstationGoldenImage"],
    DISPLAY_GATEWAY: ["DisplayGatewayImage"],
    CONTAINER: ["ContainerImage"],
    DATABASE: ["DatabaseImage"],
    NODE: ["NodeImage", "NodeGoldenImage"],
    VPN_GATEWAY: ["VirtualPrivateNetworkGatewayImage"],
    SNOWFLAKE: ["SnowflakeImage", "SnowflakeGoldenImage"]
  },
  SIZE: "Size",
  SIZES: {
    WORKSTATION: "WorkstationSize",
    DISPLAY_GATEWAY: "DisplayGatewaySize",
    CONTAINER: "ContainerSize",
    DATABASE: "DatabaseSize",
    NODE: "NodeSize",
    VPN_GATEWAY: "VirtualPrivateNetworkGatewaySize",
    SNOWFLAKE: "SnowflakeSize"
  },
  TIMEZONE: "Timezone",
  INVOICE: "Invoice",
  INVITE: "Invite",
  PROJECT: "Project",
  CONNECTION: "Connection",
  USAGE: "Usage",
  WORKSTATION: "Workstation",
  DISPLAY_GATEWAY: "DisplayGateway",
  CONTAINER: "Container",
  SSH_KEY: "SSHKey",
  VPN_GATEWAY: "VirtualPrivateNetworkGateway",
  SNOWFLAKE: "Snowflake",
  DATABASE: "Database",
  NODE: "Node",
  WORKSTATION_PLANNER: "WorkstationPlanner",
  DISPLAY_GATEWAY_PLANNER: "DisplayGatewayPlanner",
  CONTAINER_PLANNER: "ContainerPlanner",
  DATABASE_PLANNER: "DatabasePlanner",
  NODE_PLANNER: "NodePlanner",
  VPN_GATEWAY_PLANNER: "VirtualPrivateNetworkGatewayPlanner",
  SNOWFLAKE_PLANNER: "SnowflakePlanner",
  SCHEDULE: "Schedule",
  INVITEE: "Invitee",
  OPERATION: "Operation",
  USER: "User",
  GROUP: "Group",
  USER_GROUP: "UserGroup",
  ESTIMATE: "Estimate",
  CONSTRAINT_VIOLATIONS: "ConstraintViolation",

  CONTAINER_IMAGE: "ContainerImage",
  DATABASE_IMAGE: "DatabaseImage",
  DISPLAY_GATEWAY_IMAGE: "DisplayGatewayImage",
  NODE_IMAGE: "NodeImage",
  NODE_GOLDEN_IMAGE: "NodeGoldenImage",
  SNOWFLAKE_IMAGE: "SnowflakeImage",
  SNOWFLAKE_GOLDEN_IMAGE: "SnowflakeGoldenImage",
  WORKSTATION_IMAGE: "WorkstationImage",
  WORKSTATION_GOLDEN_IMAGE: "WorkstationGoldenImage",
  VPN_GATEWAY_IMAGE: "VirtualPrivateNetworkGatewayImage",

  MESSAGE: "Message"
};

// -- RESOURCE KEYS -- //

// the key names used on returned entity objects
export const RESOURCE_KEYS = {
  PROJECTS: "projects",
  WORKSTATIONS: "workstations",
  DISPLAY_GATEWAYS: "displayGateways",
  CONTAINERS: "containers",
  DATABASES: "databases",
  NODES: "nodes",
  VPN_GATEWAYS: "virtualPrivateNetworkGateways",
  SNOWFLAKES: "snowflakes",
  WORKSTATION_PLANNERS: "workstationPlanners",
  DISPLAY_GATEWAY_PLANNERS: "displayGatewayPlanners",
  CONTAINER_PLANNERS: "containerPlanners",
  DATABASE_PLANNERS: "databasePlanners",
  NODE_PLANNERS: "nodePlanners",
  VPN_GATEWAY_PLANNERS: "virtualPrivateNetworkGatewayPlanners",
  SNOWFLAKE_PLANNERS: "snowflakePlanners",
  INVITES: "invites",
  SCHEDULES: "schedules",
  INVOICES: "invoices",
  IMAGES: "images",
  SOURCE: "source",
  CHARGE: "charge",
  USAGE: "usage"
};

// the key names extracted by react-router in the match.props object
export const RESOURCE_URI_CHUNKS = {
  RESOURCES: "resources",
  PROJECTS: "projects",
  WORKSTATIONS: "workstations",
  DISPLAY_GATEWAYS: "displaygateways",
  CONTAINERS: "containers",
  DATABASES: "databases",
  NODES: "nodes",
  VPN_GATEWAYS: "virtualprivatenetworkgateways",
  SNOWFLAKES: "snowflakes",
  WORKSTATION_PLANNERS: "workstationplanners",
  DISPLAY_GATEWAY_PLANNERS: "displaygatewayplanners",
  CONTAINER_PLANNERS: "containerplanners",
  DATABASE_PLANNERS: "databaseplanners",
  NODE_PLANNERS: "nodeplanners",
  VPN_GATEWAY_PLANNERS: "virtualprivatenetworkplanners",
  SNOWFLAKE_PLANNERS: "snowflakeplanners",
  INVITES: "invites",
  SCHEDULES: "schedules",
  IMAGES: "images",
  INVOICES: "invoices",
  USERS: "users"
};

// the key names extracted by react-router in the match.props object
export const ACTION_URI_CHUNKS = {
  CREATE: "create",
  CLONE: "clone"
};

// -- RESOURCE KEY COLLECTIONS -- //

export const ALL_RESOURCE_KEYS = [
  RESOURCE_KEYS.WORKSTATIONS,
  RESOURCE_KEYS.DISPLAY_GATEWAYS,
  RESOURCE_KEYS.CONTAINERS,
  RESOURCE_KEYS.DATABASES,
  RESOURCE_KEYS.NODES,
  RESOURCE_KEYS.VPN_GATEWAYS,
  RESOURCE_KEYS.SNOWFLAKES
];

export const ALL_PLANNER_KEYS = [
  RESOURCE_KEYS.WORKSTATION_PLANNERS,
  RESOURCE_KEYS.DISPLAY_GATEWAY_PLANNERS,
  RESOURCE_KEYS.CONTAINER_PLANNERS,
  RESOURCE_KEYS.DATABASE_PLANNERS,
  RESOURCE_KEYS.NODE_PLANNERS,
  RESOURCE_KEYS.VPN_GATEWAY_PLANNERS,
  RESOURCE_KEYS.SNOWFLAKE_PLANNERS
];

// resources types that are actively used by users
export const USER_RESOURCE_KEYS = [
  RESOURCE_KEYS.WORKSTATIONS,
  RESOURCE_KEYS.CONTAINERS,
  RESOURCE_KEYS.DATABASES,
  RESOURCE_KEYS.NODES
];

export const USER_PLANNER_KEYS = [
  RESOURCE_KEYS.WORKSTATION_PLANNERS,
  RESOURCE_KEYS.CONTAINER_PLANNERS,
  RESOURCE_KEYS.DATABASE_PLANNERS,
  RESOURCE_KEYS.NODE_PLANNERS
];

// resources types that are used in the core infrastructure
export const CORE_RESOURCE_KEYS = [
  RESOURCE_KEYS.DISPLAY_GATEWAYS,
  RESOURCE_KEYS.VPN_GATEWAYS,
  RESOURCE_KEYS.SNOWFLAKES
];

export const CORE_PLANNER_KEYS = [
  RESOURCE_KEYS.DISPLAY_GATEWAY_PLANNERS,
  RESOURCE_KEYS.VPN_GATEWAY_PLANNERS,
  RESOURCE_KEYS.SNOWFLAKE_PLANNERS
];

export const URL_ACTIONS = {
  MANAGE: "manage"
};

// -- AT TYPE MAPS -- //

export const AT_TYPES_TO_KEYS = {
  [AT_TYPES.PROVIDER]: "PROVIDER",
  [AT_TYPES.REGION]: "REGION",
  [AT_TYPES.COMPUTE_REGION]: "REGION",
  [AT_TYPES.WORKSTATION]: "WORKSTATION",
  [AT_TYPES.DISPLAY_GATEWAY]: "DISPLAY_GATEWAY",
  [AT_TYPES.CONTAINER]: "CONTAINER",
  [AT_TYPES.DATABASE]: "DATABASE",
  [AT_TYPES.NODE]: "NODE",
  [AT_TYPES.VPN_GATEWAY]: "VPN_GATEWAY",
  [AT_TYPES.SNOWFLAKE]: "SNOWFLAKE"
};

export const RESOURCE_AT_TYPES = [
  AT_TYPES.WORKSTATION,
  AT_TYPES.DISPLAY_GATEWAY,
  AT_TYPES.CONTAINER,
  AT_TYPES.DATABASE,
  AT_TYPES.NODE,
  AT_TYPES.VPN_GATEWAY,
  AT_TYPES.SNOWFLAKE
];

export const AT_TYPES_TO_RESOURCE_KEYS = {
  [AT_TYPES.WORKSTATION]: RESOURCE_KEYS.WORKSTATIONS,
  [AT_TYPES.DISPLAY_GATEWAY]: RESOURCE_KEYS.DISPLAY_GATEWAYS,
  [AT_TYPES.CONTAINER]: RESOURCE_KEYS.CONTAINERS,
  [AT_TYPES.DATABASE]: RESOURCE_KEYS.DATABASES,
  [AT_TYPES.NODE]: RESOURCE_KEYS.NODES,
  [AT_TYPES.VPN_GATEWAY]: RESOURCE_KEYS.VPN_GATEWAYS,
  [AT_TYPES.SNOWFLAKE]: RESOURCE_KEYS.SNOWFLAKES,
  [AT_TYPES.IMAGES]: RESOURCE_KEYS.IMAGES
};
